/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, leftValue: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightValue: NonNullable<unknown> }} Chain_Page_Compare_Gov_Type_Right_BetterInputs */



/**
* | output |
* | --- |
* | "{leftChain} {leftValue} governance is worse than {rightChain} {rightValue} governance" |
*
* @param {Chain_Page_Compare_Gov_Type_Right_BetterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_gov_type_right_better = /** @type {((inputs: Chain_Page_Compare_Gov_Type_Right_BetterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Gov_Type_Right_BetterInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.leftValue} governance is worse than ${i?.rightChain} ${i?.rightValue} governance`)
});